import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { fetchUnitsList } from "./unitsThunks"; 
import { Button, Card, Grid, Typography } from "antd";
import { ArrowLeftOutlined,} from "@ant-design/icons";
import UnitsList from "./components/UnitsList";
import { useNavigate } from "react-router-dom";

const  {Title} =  Typography;

const Units = () => {
  const dispatch = useDispatch();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { units } = useSelector((state) => state.units);

  const navigate =useNavigate();
  const handleNavigateToBack = () => {
    navigate("/inventory/dashboard");
  };

  useEffect(() => {
    dispatch(fetchUnitsList());
  }, [dispatch]);

  return (   
    <>
    
    <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "24px",
        }}
      >
        <Button
          type="text"
          icon={<ArrowLeftOutlined style={{ fontSize: !screens.md ? "18px" : "22px" }} />} // ✅ Scaled to match Title
			    onClick={handleNavigateToBack}
          style={{
            marginRight: 12,
            padding: 0,
            height: "auto",
            lineHeight: "1",
            color: "#000", // optional, keeps consistent with text color
          }}
        />
        <Title
          level={!screens.md ? 4 : 2}
          style={{
            margin : 0,
            whiteSpace: "normal",
            wordBreak: "break-word",
            textAlign: !screens.md ? "center" : "left",
          }}
        >
          Item Units List
        </Title>
      </div>
    <UnitsList unitsList={units} />
        </>
  );
};

export default Units;
